import React from 'react';

import { flagStyles } from '../settings';

const SvgUA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5448px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgUA;
